module.exports = __webpack_public_path__ + "img/hometoponecopy.34e1d6bd.jpg";